<template>
  <teleport to="body">
    <div v-if="visible" class="context-menu" :style="{ left: x + 'px', top: y + 'px' }" @click.stop>
      <div class="menu-item" @click="handleRestart">
        <span>重启云机</span>
      </div>
      <div class="menu-item" @click="handleReset">
        <span>重置云机</span>
      </div>
      <div class="menu-item" @click="handleOneKeyNew">
        <span>一键新机</span>
      </div>
      <div class="menu-item" @click="handleChangeModel">
        <span>更换机型</span>
      </div>
      <div class="menu-item" @click="handleTransfer">
        <span>转移云机</span>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const visible = ref(false);
const x = ref(0);
const y = ref(0);
const phoneId = ref('');
const client = ref<any>(null);

const emit = defineEmits(['restart', 'reset', 'oneKeyNew', 'changeModel', 'transfer']);

const show = (event: MouseEvent, id: string, clientInstance: any) => {
  x.value = event.clientX;
  y.value = event.clientY;
  phoneId.value = id;
  client.value = clientInstance;
  visible.value = true;
};

const hide = () => {
  visible.value = false;
};

const handleRestart = () => {
  emit('restart', phoneId.value, client.value);
  hide();
};

const handleReset = () => {
  emit('reset', phoneId.value, client.value);
  hide();
};

const handleOneKeyNew = () => {
  emit('oneKeyNew', phoneId.value, client.value);
  hide();
};

const handleChangeModel = () => {
  emit('changeModel', phoneId.value, client.value);
  hide();
};

const handleTransfer = () => {
  emit('transfer', phoneId.value, client.value);
  hide();
};

const handleClickOutside = () => {
  hide();
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

defineExpose({ show, hide });
</script>

<style scoped>
.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999;
  padding: 4px 0;
  min-width: 120px;
}

.menu-item {
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: background-color 0.2s;
}

.menu-item:hover {
  background-color: #f5f7fa;
}
</style>
